import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/**
 * 元信息
 * meta
 * disAnimation 路由跳转是否需要动画
 */

const router = new Router({
  routes: [
    { path: '/', redirect: '/home', hidden: true },
    {
      path: '/home',
      component: () => import('@/views/home/index'),
      meta: {
        defaultRoute: true
      }
    },
    {
      path: '/test',
      component: () => import('@/views/test'),
      meta: {
        defaultRoute: true
      }
    },
    {
      path: '/test2',
      component: () => import('@/views/test')
    },
    {
      path:'/order_management',
      component:()=>import('@/views/order_management'),
    },
    {
      path:'/order_details',
      component:()=>import('@/views/order_details'),
    },
    {
      path:'/After_sales',
      component:()=>import('@/views/After_sales'),
    },
    {
      path:'/Withdrawal',
      component:()=>import('@/views/Withdrawal'),
    },
    {
      path:'/Upload',
      component:()=>import('@/views/Upload'),
    },
    {
      path:'/goods',
      component:()=>import('@/views/goods'),
    },
    {
      path:'/recive',
      component:()=>import('@/views/recive'),
    }
  ]
})

// 根据具体的跳转类型更改跳转属性值，执行不同的动画
const nextDirection = direction => {
  let el = document.getElementById('app')
  if (el) el.setAttribute('transition-direction', direction)
}

router['_push'] = router['push']
router['_replace'] = router['replace']

// 重写路由跳转方法，设置跳转类型后跳转
router.forward = router['push'] = target => {
  nextDirection('forward')
  setTimeout(() => {
    router['_push'](target)
  })
}
router.replace = target => {
  nextDirection('forward')
  setTimeout(() => {
    router['_replace'](target)
  })
}

// 重写路由返回方法，设置跳转类型后跳转到上一页
router.back = target => {
  nextDirection('back')
  router.isBack = true
  if (target) {
    setTimeout(() => {
      router['_push'](target)
    })
  }
  history.go(-1)
}

export default router
